import { makeAutoObservable } from "mobx";

export interface Split {
	id: string;
	name: string;
	splitPercentages?: SplitPercentage[];
	isActive: boolean;
}

export interface SplitPercentage {
	splitId: string;
	accountId: string;
	accountName: string;
	isActive: boolean;
	splitPercent: number;
}

export class SplitModel implements Split {
	readonly id: string;
	name: string;
	splitPercentages: SplitPercentage[] = [];
	isActive: boolean = true;

	constructor(split: Split) {
		makeAutoObservable(this);
		this.id = split.id;
		this.name = split.name;
		this.isActive = split.isActive;
		this.splitPercentages = split.splitPercentages || [];
	}
	get canSave() {
		//  && this.splitPercentages.every(sp => sp.splitPercent >= 0 && sp.splitPercent <= 100)
		return this.name.trim().length > 0;
	}
	setName(name: string) {
		this.name = name;
	}
	setIsActive(isActive: boolean) {
		this.isActive = isActive;
	}
}